import { useEffect, useState } from "react";
import useAxios from "axios-hooks";

const useCreateActionItem = (
  setActionItems,
  checklistId,
  checklist
) => {
  const [createdActionItemId, setCreateActionItemId] = useState();
  const [allActionItems, setAllActionItems] = useState([]);
  //const [newActionItem, setNewActionItem] = useState();

  //Api call to create the action item
  const [
    { data: createdActionItemData, loading: creatingActionItem },
    createActionItem,
  ] = useAxios({ url: `action-item/`, method: "post" }, { manual: true });

  //Get the action item's id

  //Take that id to call the get endpoint to get the action item
  const [
    { data: actionItemData, loading: getActionItemLoading },
    executeGetActionItem,
  ] = useAxios({}, { manual: true });

  const [
    { data: allActionItemsData, loading: loadingAllActionItems },
  ] = useAxios("action-items");

  useEffect(() => {
    if (allActionItemsData && !loadingAllActionItems) {
      setAllActionItems(allActionItemsData);
    }
  }, [allActionItemsData, loadingAllActionItems]);

  useEffect(() => {
    if (!!createdActionItemData && !creatingActionItem) {
      setCreateActionItemId(createdActionItemData.actionItemID);
    }
  }, [createdActionItemData, creatingActionItem]);

  useEffect(() => {
    if (createdActionItemId) {
      executeGetActionItem({
        url: `action-item/${createdActionItemId}`,
        method: "get",
      });
      setCreateActionItemId(null);
    }
  }, [createdActionItemId, executeGetActionItem]);

  useEffect(() => {
    if (!!actionItemData && !getActionItemLoading) {
      setAllActionItems((prev) => [...prev, actionItemData]);
      const defaultRequirement = checklist?.completionRules === "Required Only" ? "Required" : "Not Required";
      setActionItems((prevActionItems) => [
        ...prevActionItems,
        {
          key: `actionItem_${actionItemData.actionItemID}`,
          actionItemID: actionItemData.actionItemID,
          checklistID: checklistId,
          orderNumber: prevActionItems.length,
          requirement: actionItemData.requirement || defaultRequirement,
          validated: true,
        },
      ]);
    }
  }, [
    actionItemData,
    checklistId,
    checklist,
    getActionItemLoading,
    setActionItems,
  ]);
  //Use that action item and call a callback function with that item as the param
  return [
    createActionItem,
    creatingActionItem,
    allActionItems,
    loadingAllActionItems,
  ];
};

export default useCreateActionItem;
